import { render, staticRenderFns } from "./InsCmsCat6.vue?vue&type=template&id=78c3b094&scoped=true&"
import script from "./InsCmsCat6.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat6.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat6.vue?vue&type=style&index=0&id=78c3b094&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3b094",
  null
  
)

export default component.exports